"use client";

import { useQuery } from "@tanstack/react-query";

import { replayMetricsApi, parseMatchTimeline } from "./validation";

/**
 * KAN-786: лента live-событий матча (Live Client Data API через Tauri).
 *
 * Типы рукописные сознательно: эндпоинт новый и в пинованный swagger ещё не попал —
 * после деплоя на тест и `make api-sync-test` можно перевести на сгенерированные.
 */

export interface MatchTimelineEvent {
  eventId: number;
  /** Тип как в Live Client: ChampionKill, DragonKill, TurretKilled, Ace, … */
  name: string;
  timeSeconds: number;
  /** Сырое событие Live Client; поля зависят от типа (KillerName, VictimName, …). */
  dataJson: string;
}

export interface MatchGameTimeline {
  gameId: number;
  events: MatchTimelineEvent[];
}

export interface MatchTimeline {
  matchId: string;
  games: MatchGameTimeline[];
}

/**
 * Лента событий матча по играм серии. Пустой список игр — события не собирались
 * (ни у кого из участников не работал desktop-клиент): штатное состояние, витрина
 * в этом случае не показывается вовсе.
 */
export function useMatchTimeline(matchId: string | undefined) {
  return useQuery({
    queryKey: ["match-timeline", matchId],
    enabled: Boolean(matchId),
    queryFn: async () => {
const data = (await replayMetricsApi.getTimeline(matchId!)).data;
      return data == null ? null : parseMatchTimeline(data);
    },
  });
}
